function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'banana': 'rgb(255, 236, 185)','hydrangea': 'rgb(190, 214, 243)','bay': 'rgb(155, 170, 152)','granite': 'rgb(138, 142, 146)','khaki': 'rgb(174, 165, 131)','orchid': 'rgb(203, 179, 204)','white': 'rgb(255, 255, 255)','washed-denim': 'rgb(133, 149, 184)','peachy': 'rgb(244, 182, 166)','chalky-mint': 'rgb(167, 217, 212)','cumin': 'rgb(211, 110, 113)','celadon': 'rgb(203, 224, 172)','chambray': 'rgb(217, 237, 245)','ice-blue': 'rgb(143, 173, 191)','strawberry-ice': 'rgb(242, 154, 150)','sandstone': 'rgb(182, 175, 157)','placid-blue': 'rgb(174, 208, 223)','lilac-gray': 'rgb(142, 137, 149)','heather-gray': 'rgb(165, 161, 173)','stone': 'rgb(170, 168, 155)','forest': 'rgb(66, 115, 109)','navy': 'rgb(85, 103, 115)','royal': 'rgb(74, 91, 135)',};

    this.images = {};

    this.triggers = ['color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
